import { WorkspaceEmailAliasKind } from "@common/constants/domains/receipts/constants";
import { getWorkspaceEmailAliasDomain } from "@common/helpers/workspace-email-alias";

export interface EmailAliasSectionCopy {
    heading: string;
    subheading: string;
    emptyBody: string;
}

const LEGACY_RECEIPTS_ALIAS_COPY: EmailAliasSectionCopy = {
    heading: "Custom forwarding address",
    subheading:
        "Create a custom forwarding address to receive receipts, invoices and bills from your Accountant. Only share your secure forwarding address with trusted contacts, as all documents received will appear in your workspace.",
    emptyBody:
        "Create a custom forwarding address to receive receipts, invoices and bills from your Accountant.",
};

export const EMAIL_ALIAS_SECTION_COPY: Record<
    WorkspaceEmailAliasKind,
    EmailAliasSectionCopy
> = {
    receipts: {
        heading: "Custom forwarding address",
        subheading:
            "Create a custom forwarding address to receive receipts from trusted contacts. Only share this address with people you trust.",
        emptyBody:
            "Create a custom forwarding address to receive receipts in this workspace.",
    },
    bills: {
        heading: "Bills addresses",
        subheading: `Give each vendor a unique @${getWorkspaceEmailAliasDomain("bills")} address. Attachments are queued as bills and linked to that vendor.`,
        emptyBody: `Create a vendor-specific ${getWorkspaceEmailAliasDomain("bills")} address to pre-assign incoming bills.`,
    },
    invoices: {
        heading: "Invoice addresses",
        subheading: `Give each customer a unique @${getWorkspaceEmailAliasDomain("invoices")} address. Attachments are queued as invoices and linked to that customer.`,
        emptyBody: `Create a customer-specific ${getWorkspaceEmailAliasDomain("invoices")} address to pre-assign incoming invoices.`,
    },
};

export function getEmailAliasSectionCopy({
    kind,
    canShowBillInvoiceInbox,
}: {
    kind: WorkspaceEmailAliasKind;
    canShowBillInvoiceInbox: boolean;
}): EmailAliasSectionCopy {
    if (kind === "receipts" && !canShowBillInvoiceInbox) {
        return LEGACY_RECEIPTS_ALIAS_COPY;
    }
    return EMAIL_ALIAS_SECTION_COPY[kind];
}
